<template>
    <v-card>
        <user-warnings></user-warnings>
        <v-card-title>
            <v-flex xs12 sm6>
                <div class="headline">Cronograma <v-chip outline color="info">Público</v-chip></div>
            </v-flex>
            <v-flex xs12 sm5>
                <v-text-field
                    append-icon="search"
                    label="Pesquisar"
                    single-line
                    hide-details
                    v-model="search">
                </v-text-field>
            </v-flex>
        </v-card-title>
        <v-card-title>
            <exam-filters
                v-model="filters"
                :options="['course','semester','enrolled']"
                :semester-required="true"
                :course-required="true"
                :can-select-any-course="true"
                :show-dev-semester="false"></exam-filters>
        </v-card-title>
        <v-card-title v-if="activeMessages.length > 0">
            <v-flex xs12>
                <v-alert :color="message.type" value="true" v-for="(message, idx) in activeMessages" :key="'message_'+idx" dismissible v-model="message.show">
                    {{ message.text }}
                </v-alert>
            </v-flex>
        </v-card-title>

        <!-- Tabela de bancas-->
        <v-data-table
            :headers="headers"
            :items="filteredItems"
            :search="search"
            :pagination.sync="pagination"
            :total-items="totalItems"
            :loading="loading"
            :no-data-text="noDataCustom"
            :no-results-text="noResultCustom"
            :rows-per-page-text="rowsPerPageT"
            class="elevation-1"
            expand>
            <template slot="items" slot-scope="props">
                <tr v-if="props.item">
                    <td v-if="isSmallScreen">
                        <v-icon>person</v-icon> Aluno:
                        <ul class="no-padding">
                            <ol class="no-padding studentName" v-for="(studentName, id) in props.item.studentName" :key="id">
                                {{ studentName }}
                            </ol>
                        </ul>
                        <br>
                        <v-icon>title</v-icon> 
                        Título: {{ props.item.title }} <br>
                        <v-icon>date_range</v-icon> Data: {{ props.item.date | moment('DD/MM/YYYY') }} às {{ props.item.hour }} <br>
                        <v-icon>date_range</v-icon> Inscrição até: {{ registrationBy(props.item) }} <br>
                        <v-icon>edit_location</v-icon> Local: {{ props.item.place }} <br>
                        <v-icon>edit_location</v-icon> Vagas: {{ props.item.vacancies }} <br>
                            <template v-if="canEnroll(props.item) || props.item.enrolled">
                                <v-chip small :color="!props.item.full ? 'success' : 'grey'" text-color="white" v-if="!authenticated || !props.item.enrolled">
                                    {{ !props.item.full ? "Inscrições abertas" : "Vagas esgotadas" }}
                                </v-chip>
                                <v-chip small color="green darken-1" text-color="white" v-if="authenticated && props.item.enrolled && !props.item.present">
                                    Inscrito
                                </v-chip>
                                <v-chip small color="info" text-color="white" v-if="authenticated && props.item.enrolled && props.item.present && !props.item.certification">
                                    Presença confirmada
                                </v-chip>
                                <v-chip small color="primary" text-color="white" v-if="authenticated && props.item.enrolled && props.item.present && props.item.certification">
                                    Presença certificada
                                </v-chip>
                            </template>
                            <template v-else>
                                <v-chip small color="grey darken-3" text-color="white" v-if="!canEnroll(props.item)">
                                    Inscrições encerradas
                                </v-chip>
                            </template>
                        <br>
                    </td>
                    <!-- <td v-if="!isSmallScreen">
                        <ul class="no-padding">
                            <ol class="no-padding">
                                {{ props.item.date | moment('DD/MM/YYYY') }}
                            </ol>
                        </ul>
                    </td>
                    <td v-if="!isSmallScreen">
                        <ul class="no-padding">
                            <ol class="no-padding">
                                {{ props.item.hour }}
                            </ol>
                        </ul>
                    </td> -->
                    <td v-if="!isSmallScreen">
                        <ul class="no-padding">
                            <ol class="no-padding studentName" v-for="(studentName, id) in props.item.studentName" :key="id">
                                {{ studentName }}
                            </ol>
                        </ul>
                    </td>
                    <td v-if="!isSmallScreen">
                        <table>
                            <div>
                                <v-card-text style="background-color: none;">
                                    <v-icon>subject</v-icon> Título: {{ props.item.title }}<br>
                                    <!-- <v-icon>subject</v-icon> Tema: {{ props.item.topic }}<br> -->
                                    <v-icon>date_range</v-icon> Data: {{ props.item.date | moment('DD/MM/YYYY') }} às {{ props.item.hour }} <br>
                                    <v-icon>date_range</v-icon> Inscrição até: {{ registrationBy(props.item) }} <br>
                                    <v-icon :title="authenticated ? props.item.registrations+' inscritos' : ''">edit_location</v-icon> Local: {{ props.item.place }} - <b>{{props.item.vacancies }} vagas </b>
                                </v-card-text>
                            </div>
                        </table>
                    </td>
                    <td v-if="!isSmallScreen" class="text-md-center">
                        <template v-if="canEnroll(props.item) || props.item.enrolled">
                            <v-chip :color="!props.item.full ? 'success' : 'grey'" text-color="white" v-if="!authenticated || !props.item.enrolled">
                                {{ !props.item.full ? "Inscrições abertas" : "Vagas esgotadas" }}
                            </v-chip>
                            <v-chip color="green darken-1" text-color="white" v-if="authenticated && props.item.enrolled && !props.item.present">
                                Inscrito
                            </v-chip>
                            <v-chip color="info" text-color="white" v-if="authenticated && props.item.enrolled && props.item.present && !props.item.certification">
                                Presença confirmada
                            </v-chip>
                            <v-chip color="primary" text-color="white" v-if="authenticated && props.item.enrolled && props.item.present && props.item.certification">
                                Presença certificada
                            </v-chip>
                        </template>
                        <template v-else>
                            <v-chip color="grey darken-3" text-color="white" v-if="!canEnroll(props.item)">
                                Inscrições encerradas
                            </v-chip>
                        </template>
                    </td>

                    <!-- <td v-bind="props.expanded = true"> -->
                    <td>
                        <template v-if="authenticated">
                            <template v-if="!props.item.full">
                                <v-btn color="success" floating small dark
                                    title="Inscrever-se como ouvinte"
                                    @click.stop="checkTime(props.item)"
                                    v-if="canEnroll(props.item) && (!authenticated || !props.item.enrolled)">
                                    <v-icon small dark left>assignment_turned_in</v-icon> Inscrever-se
                                </v-btn>
                            </template>
                            <v-btn color="warning" floating small dark
                                title="Cancelar inscrição como ouvinte"
                                @click.stop="showExamEnroll(props.item, false)"
                                v-if="canEnroll(props.item) && (authenticated && props.item.enrolled && !props.item.present)">
                                <v-icon small dark left>assignment_late</v-icon> Cancelar inscrição
                            </v-btn>
                        </template>
                    </td>
                </tr>
            </template>
        </v-data-table>

        <fullscreen-spinner></fullscreen-spinner>
        <v-dialog v-model="enrollDialog" lazy max-width="600px">
            <v-card>
                <v-toolbar dark :class="enrollAction ? 'success' : 'warning'">
                    <v-toolbar-title>Confirma {{ enrollAction === false ? 'o cancelamento d' : '' }}a sua inscrição na banca abaixo?</v-toolbar-title>
                </v-toolbar>
                <exam-detail-list :exam="selectedExam"></exam-detail-list>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="enroll">Confirmar</v-btn>
                    <v-btn color="info" @click="enrollDialog = false">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="loginDialog" lazy max-width="600px">
            <login :redirect="false" :fullscreen="false" @logged-in="closeLoginDialogAndFinishEnroll">
                <template slot="actions">
                    <v-spacer></v-spacer>
                    <v-btn color="info" @click="loginDialog = false">Fechar</v-btn>
                </template>
            </login>
        </v-dialog>
    </v-card>
</template>

<script>
    import { noData, noResult, rowsPerPageT } from './../locale/vuetify'
    import auth from './../auth'
    import moment from 'moment'
    import Login from './Login.vue'
    import ExamFilters from './ExamFilters.vue'
    import ExamDetailList from './ExamDetailList.vue'
    import UserWarnings from './UserWarnings.vue'

    export default {
        name: 'ExamSchedule',
        components: {
            Login,
            ExamFilters,
            ExamDetailList,
            UserWarnings
        },
        props: {
            courseSlug: {
                type: [String],
                default: ''
            }
        },
        data() {
            return {
                desktopHeaders: [
                    // { text: 'Data', align: 'left', value: 'date' },
                    // { text: 'Hora', align: 'left', value: 'hour' },
                    { text: 'Aluno', align: 'left', value: 'studentName' },
                    //{ text: 'Tema', align: 'left', value: 'topic' },
                    { text: 'Informações', align: 'left', value: 'title' },
                    //{ text: 'Local', align: 'left', value: 'place' },
                    { text: 'Situação', align: 'center', value: 'status' },
                    { text: 'Ações', align: 'center', value: 'actions' }
                ],
                mobileHeaders: [
                    { text: 'Banca', align: 'left', value: 'short'},
                    //{ text: 'Situação', align: 'center', value: 'status' },
                    { text: 'Ações', align: 'center', value: 'actions' }
                ],
                items: [],
                totalItems: -1,
                search: '',
                pagination: {
                    rowsPerPage: 10,
                    sortBy: 'date',
                    descending: false
                },
                loading: false,
                loadingError: false,
                rowsPerPageT: rowsPerPageT,
                selectedExam: null,
                enrollAction: null,
                enrollDialog: false,
                loginDialog: false,
                messages: [],
                filters: {},
                bancasExcecao: {}
            }
        },
        computed: {
            filteredItems() {
                return this.items.filter(item => item.situation !== 'Cancelada');
            },            
            dataAtual(){
                var data = new Date();
                var dia = String(data.getDate()).padStart(2, '0');
                var mes = String(data.getMonth() + 1).padStart(2, '0');
                var ano = data.getFullYear();
                // const dataAtual = dia + '/' + mes + '/' + ano;
                const dataAtual = ano + '-' + mes + '-' + dia;
                // console.log(dataAtual); 
                return dataAtual
            },
            horaAtual(){
                var data = new Date();
                var hora = String(data.getHours()).padStart(2, '0');
                var minuto = String(data.getMinutes()).padStart(2, '0');
                
                const horaAtual = hora + ':' + minuto;
                // console.log(horaAtual); 
                return horaAtual
            },
            isSmallScreen() {
                return ['xs','sm'].includes(this.$vuetify.breakpoint.name)
            },
            headers() {
                return this.isSmallScreen ? this.mobileHeaders : this.desktopHeaders
            },
            activeMessages: function() {
                return this.messages.filter(function (message) {
                    return message['date'] >= (Date.now() - (5 * 1000))
                })
            },
            authenticated: function() {
                return auth.user.authenticated
            },
            noDataCustom: function() {
                if (this.loadingError) {
                    return this.loadingError
                } else {
                    return noData
                }
            },
            noResultCustom: function() {
                if (this.loadingError) {
                    return this.loadingError
                } else {
                    return noResult
                }
            }
        },
        watch: {
            pagination: {
                handler() { this.refresh() },
                deep: true
            },
            filters: {
                handler() { this.refresh() },
                deep: true
            },
            authenticated: {
                handler() { this.refresh() }
            }
        },
        methods: {
            registrationBy(exam) {
                // Data e hora do exame
                const dataBanca = new Date(exam.date + "T" + exam.hour);

                // Subtrai 1 dia do exame e ajusta para 23:59:59
                const dataLimite = new Date(dataBanca);
                dataLimite.setDate(dataLimite.getDate() - 1);
                dataLimite.setHours(23, 59, 59);

                // Formatar a data e a hora no formato "DD/MM/AA HH:MM:SS"
                const ano = String(dataLimite.getFullYear()).slice(-2); // Ano com duas casas
                const mes = String(dataLimite.getMonth() + 1).padStart(2, '0'); // Mês é zero-indexado
                const dia = String(dataLimite.getDate()).padStart(2, '0');
                const horas = String(dataLimite.getHours()).padStart(2, '0');
                const minutos = String(dataLimite.getMinutes()).padStart(2, '0');
                const segundos = String(dataLimite.getSeconds()).padStart(2, '0');

                // Retornar a data no formato brasileiro DD/MM/AA às HH:MM:SS
                return `${dia}/${mes}/${ano} às ${horas}:${minutos}:${segundos}`;
            },
            checkTime(props){
                var data = new Date();
                var dia = String(data.getDate()).padStart(2, '0');
                var mes = String(data.getMonth() + 1).padStart(2, '0');
                var ano = data.getFullYear();

                var hora = String(data.getHours()).padStart(2, '0');
                var minuto = String(data.getMinutes()).padStart(2, '0');
                
                const dataAtual = ano + '-' + mes + '-' + dia;
                const horaAtual = hora + ':' + minuto;

                const dataBanca = new Date(props.date+"T"+props.hour);
                const dataAgora = new Date(dataAtual+"T"+horaAtual);


                if (dataBanca.getTime() === dataAgora.getTime()) {
                    // console.log('As datas são iguais');
                    this.$swal({
                        type: 'warning',
                        text: 'Inscrição fora do prazo',
                        showConfirmButton: false,
                        timer: 2500
                    })
                }
                else if (dataBanca.getTime() > dataAgora.getTime()) {
                    // data da banca não passou
                    // console.log(dataBanca.toString() + ' maior que ' + dataAgora.toString());
                    var bancas = this.conflitoHorario(dataBanca);
                    if(bancas.length > 0){
                        var ids = [];
                        bancas.map(banca =>{
                            ids.push(banca.title);
                        })
                        
                        this.$swal({
                            type: 'warning',
                            text: `Você já está inscrito em uma banca no mesmo horário, Banca: ${ids.toString()}`,
                            showConfirmButton: true,
                            // timer: 2500
                        })
                    }else{
                        this.showExamEnroll(props, true);
                    }
                }
                else {
                    // data da banca já passou
                    // console.log(dataBanca.toString() + ' menor que ' + dataAgora.toString());
                    this.$swal({
                        type: 'warning',
                        text: 'Inscrição fora do prazo',
                        showConfirmButton: false,
                        timer: 2500
                    })
                }
            },   
            conflitoHorario(dataBanca){
                var bancas = this.items.filter((valorAtual, indice, varArray)=>{
                    var dataBancas = new Date(valorAtual.date+"T"+valorAtual.hour);
                    if((valorAtual.enrolled == 1) && (dataBancas.getTime() === dataBanca.getTime())){
                        return valorAtual;
                    }
                })
                return bancas;
                // console.log(bancas)
                
            },
            formatDate: function (date) {
                return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY')
            },
            mountSearchString() {
                let searchString = [];

                for (let key in this.filters) {
                    let value = this.filters[key]
                    if (!!value && key != 'view') {
                        searchString[key] = value
                    }
                }
                searchString['search'] = this.search;

                let str = "";
                for (let key in searchString) {
                    if (str != "") {
                        str += "&";
                    }
                    str += key + "=" + encodeURIComponent(searchString[key]);
                }

                return str

            },
            getDataFromApi() {
                this.loading = true
                this.loadingError = false
                const { sortBy, descending, page, rowsPerPage } = this.pagination
                let offset = 0;
                if (rowsPerPage > 0) offset = (page - 1) * rowsPerPage

                const params = {
                    search: this.mountSearchString(),
                    sortBy: this.pagination.sortBy,
                    descending: this.pagination.descending,
                    limit: rowsPerPage,
                    offset: offset
                }

                // examSchedule | searchExamSchedule
                this.$http.post('searchExamSchedule', params).then(response => {
                    this.loading = false
                    this.items = response.body
                    this.totalItems = parseInt(response.headers.get('X-Pagination-Total-Count'))
                }, response => {
                    this.loading = false
                    console.error('Erro ao carregar as bancas do servidor.')
                    console.log(response)
                    if (response.data && typeof response.data.errors !== 'undefined') {
                        this.loadingError = response.data.errors.join(' | ')
                    }
                    this.items = []
                    this.totalItems = 0
                })
            },
            showExamEnroll(exam, action) {
                this.selectedExam = exam
                this.enrollAction = action
                if (!auth.user.authenticated) {
                    this.loginDialog = true
                } else {
                    this.enrollDialog = true
                }
            },
            addMessage(type, text) {
                this.messages.push({
                    'type': type,
                    'text': text,
                    'date': Date.now(),
                    'show': true
                })
            },
            refresh() {
                this.getDataFromApi()
            },
            // canEnroll(exam) {
            //     var data = new Date();
            //     var dia = String(data.getDate()).padStart(2, '0');
            //     var mes = String(data.getMonth() + 1).padStart(2, '0');
            //     var ano = data.getFullYear();

            //     var hora = String(data.getHours()).padStart(2, '0');
            //     var minuto = String(data.getMinutes()).padStart(2, '0')
                
            //     const dataAtual = ano + '-' + mes + '-' + dia;
            //     const horaAtual = hora + ':' + minuto;

            //     const dataBanca = new Date(exam.date+"T"+exam.hour);
            //     const dataAgora = new Date(dataAtual+"T"+horaAtual);
            //     console.log(dataBanca)

            //     return dataAgora.getTime() < dataBanca.getTime();
            // },
            canEnroll(exam) {
                var data = new Date();
                var dia = String(data.getDate()).padStart(2, '0');
                var mes = String(data.getMonth() + 1).padStart(2, '0');
                var ano = data.getFullYear();

                var hora = String(data.getHours()).padStart(2, '0');
                var minuto = String(data.getMinutes()).padStart(2, '0');
                var segundo = String(data.getSeconds()).padStart(2, '0');
                
                // Data e hora atuais formatadas
                const dataAtual = ano + '-' + mes + '-' + dia;
                const horaAtual = hora + ':' + minuto + ':' + segundo;

                // Data e hora do exame
                const dataBanca = new Date(exam.date + "T" + exam.hour);

                // Subtrai 1 dia do exame e ajusta para 23:59:59
                const dataLimite = new Date(dataBanca);
                dataLimite.setDate(dataLimite.getDate() - 1); // Subtrai um dia
                dataLimite.setHours(23, 59, 59); // Define para 23:59:59

                // Data e hora atuais como objeto Date
                const dataAgora = new Date(dataAtual + "T" + horaAtual);

                // console.log('Data do exame:', dataBanca);
                // console.log('Data limite de inscrição:', dataLimite);
                // console.log('Data atual:', dataAgora);

                // Verifica se a data atual é anterior à data limite de inscrição
                return dataAgora.getTime() < dataLimite.getTime();
            },
            closeLoginDialogAndFinishEnroll() {
                this.loginDialog = false
                this.enrollDialog = true
            },
            enroll() {
                let url = this.enrollAction ? 'enroll' : 'unenroll',
                    action = this.enrollAction ? 'realizar' : 'cancelar',
                    actionResult = this.enrollAction ? 'realizada' : 'cancelada',
                    exam = this.selectedExam
                this.$http.post(url, { exam: exam.id }).then(response => {
                    if (typeof response.data.status !== 'undefined' && response.data.status == 'ok') {
                        this.addMessage('success', 'Inscrição ' + actionResult + ' com sucesso na banca ' + exam.id + '!')
                        // exam.enrolled = !exam.enrolled doesnt work after closeLoginDialogAndFinishEnroll
                        for (let exam_ of this.items) {
                            if (exam_.id == exam.id) {
                                exam_.enrolled = !exam_.enrolled
                                break
                            }
                        }
                    } else {
                        this.addMessage('error', 'Não foi possível '+action+' sua inscrição na banca ' + exam.id + '.')
                        this.handleErrors(response.data.errors)
                    }
                }, response => {
                    this.addMessage('error', 'Não foi possível '+action+' sua inscrição na banca ' + exam.id + '.')
                    this.handleErrors(response.data.errors)
                })
                this.enrollDialog = false
            },
            handleErrors(errors) {
                if (typeof errors !== 'undefined') {
                    for (let error of errors) {
                        this.addMessage('error', error)
                    }
                    return true
                } else {
                    return false
                }
            },
            bancasExcecaoBridge() {
                this.$http.post('bancasExcecao').then(response => {
                    this.bancasExcecao = response.body;
                }, response => {
                    this.loading = false
                    console.error('Erro ao carregar as bancas do servidor.')
                    console.log(response)
                })
            }
        },
        created() {
            if (this.courseSlug) {
                this.filters.course = this.courseSlug
            }
        },
        mounted() {
            this.refresh();
            this.bancasExcecaoBridge();
        }
    }
</script>

<style scoped>
    tbody tr:nth-child(odd) {
        background: #eee;
    }
</style>



// WEBPACK FOOTER //
// ExamSchedule.vue?3f47a1f4